import { FunctionComponent } from 'react';
import { IconEnvelope } from '@tock/icons';
import { SlimPatron } from '@tock/shared/utils/patron';
import { Typography, TypographyProps } from 'omakase';

export interface ReservationPatronEmailDetailProps {
  purchaseOwner?: SlimPatron & { id: number };
  typographyVariant?: TypographyProps['variant'];
}

export const ReservationPatronEmailDetail: FunctionComponent<ReservationPatronEmailDetailProps> = ({
  purchaseOwner,
  typographyVariant = 'body02',
}) => {
  return (
    <li>
      <IconEnvelope />
      <Typography
        component="span"
        variant={typographyVariant}
        color="fgDefault"
        data-testid="guest-email-info"
      >
        {purchaseOwner?.email}
      </Typography>
    </li>
  );
};
